import { initGameWindowStyles } from '@style-desktop-v2-import';
import { initHomepageSlider } from '../../../homepage-slider/homepage-slider';

const SIDEBAR_EVENT_INITED = false;

export async function runGameClickEventHandler(gameId, isDemo = false) {
  const [
    { findGameById, checkFavoriteGame },
    { getAllGames },
    { initializeGameWindowCollections },
    { initializeGameWindowRating }
  ] = await Promise.all([
    import('../../utilities'),
    import('../../get-all-games'),
    import('../../window/dynamic/elements/collections'),
    import('../../window/dynamic/elements/rating')
  ]);

  initGameWindowStyles();

  if (!SIDEBAR_EVENT_INITED) {
    window.addEventListener('GAME_SIDEBAR_UPDATE', () => {
      const tournamentGamesElement = document.querySelector('#tournamentGames');
      if (tournamentGamesElement && tournamentGamesElement.swiper) {
        tournamentGamesElement.swiper.update();
      }
    });
  }

  const allGames = await getAllGames();
  const gameObj = findGameById(allGames, gameId);

  const modalGameElement = document.querySelector('.gamepopup .modal-game'),
    nameElement = modalGameElement.querySelector('.js-game-name'),
    favElement = modalGameElement.querySelector('.js-favourites'),
    sidebarElements = modalGameElement.querySelectorAll('.sidebar, .sidebar-addon'),
    tournamentElement = modalGameElement.querySelector('.sidebar-tournament'),
    backgroundElement = modalGameElement.querySelector('.modal-game-background img');

  if (nameElement) nameElement.innerText = gameObj.name;
  if (favElement) {
    favElement.classList.toggle('js-faved', await checkFavoriteGame(gameId));
    favElement.setAttribute('data-game-id', gameId);
  }
  if (modalGameElement) modalGameElement.setAttribute('data-game-id', gameId);
  if (backgroundElement) backgroundElement.src = `/images/uploads/games-thumbs/x300/${gameId}.jpg`;

  sidebarElements.forEach((element) => {
    element.classList.remove('active');
  });

  initializeGameWindowCollections();
  initializeGameWindowRating(gameObj);

  setTimeout(() => {
    const swiperEls = modalGameElement.querySelectorAll('.swiper-container');
    for (const swiperEl of swiperEls) swiperEl.swiper?.update();
  }, 700);

  if (!isDemo) {
    const { initCashbackProgressBar } = await import('../../both/game-window/cashback/progress-bar');
    initCashbackProgressBar();
  }

  const { initNotificationsService } = await import('../../window/service/notification-service');
  initNotificationsService();

  const gameProvidersEls = modalGameElement.querySelectorAll('.games-operators.modal-games');
  for (const gameProvidersEl of gameProvidersEls) initHomepageSlider(null, gameProvidersEl);

  if (gameObj) {
    initTags(modalGameElement, gameObj);
  }
  if (tournamentElement) {
    const { initTournament } = await import('@games/desktop/game-window/tournament/tournament');
    initTournament(gameObj);
  }
}

/*async function getGameWindowTags() {
  const { getAPIURL, getJSON } = await import(
    "../../../tools/basic-functions.js"
  );
  const jsonKey = `${_CMS_LANGUAGE}/json/search-tags.json`,
    jsonUrl = getAPIURL(jsonKey, null, true);
  var data = await getJSON(jsonUrl);
  return data;
}*/

async function initTags(wrapper, gameObj) {
  if (!gameObj.tags) {
    return;
  }
  const tagsData = gameObj.tags.map((tagName) => tagName.replaceAll('-', ' ')),
    tagsContainer = wrapper.querySelector('.tags .tag-body ul');
  if (!tagsContainer) return;
  if (tagsContainer.childElementCount) {
    tagsContainer.innerHTML = '';
  }
  for (const tagData of tagsData) {
    const tagEl = await createTagEl(tagData);

    tagEl.addEventListener('click', async () => {
      const { createGamesSearchModal } = await import('../game-search/games-search-desktop'),
        searchModalEl = await createGamesSearchModal(),
        searchInput = searchModalEl.querySelector('.search-input'),
        event = new Event('input', {
          bubbles: true,
          cancelable: true
        });
      searchInput.value = tagData;
      searchInput.dispatchEvent(event);
      setTimeout(() => searchInput.blur(), 100);
    });

    tagsContainer.append(tagEl);
  }
}

async function createTagEl(name) {
  const { createEl } = await import('../../../tools/basic-functions.js');
  return createEl(`<li class="btn btn-rounded btn-tag"><a >${name}</a></li>`);
}

export async function stopGameEventHandler() {
  const { destroyCashbackProgressBar } = await import('../../both/game-window/cashback/progress-bar');
  destroyCashbackProgressBar();
}
